import loginModel from '../../models/login.model';
import ViewBase from '../view-base.view';

export default function AgreementView() {

  ViewBase.call(this);
  const LICENSE_URL = loginModel.credentials?.eulaURL || '';
  const POLICY_URL = loginModel.credentials?.privacyURL || '';
  const SECURITY_GUIDELINE_URL = '/agreement/security-guideline';
  let agreementForm = { licenceAgreement: false, policyAgreement: false, securityAgreement: false }

  let agreePolicy = (e) => {
    e.preventDefault();
    this.showLoading();
    loginModel.userAgreement()
      .then(() => { m.route.set("/home") })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  function disagreePolicy(e) {
    loginModel.logout()
      .then(() => {
        m.route.set("/login");
      });
  }

  function areAllChecked() {
    return agreementForm.licenceAgreement && agreementForm.policyAgreement && agreementForm.securityAgreement;
  }

  function updateAgreement(e) {
    agreementForm[e.target.name] = e.target.checked;
  }

  return {
    oninit: () => {
      // Redirect back to login page if not authenticated
      if (!loginModel.isAuthenticated()) {
        m.route.set("/login");
      }
    },
    view: (vnode) => {
      return m('.d-flex.vw-100.vh-100.align-items-center.justify-content-center',
        m('.card.m-3',
          m('.card-body.px-3.px-sm-5.py-4', { style: 'max-width: 560px;' },
            m('h2.text-center.mt-2.mb-4.fs-4', 'User Agreement'),
            m('form.row.g-2', { onsubmit: agreePolicy },
              m('.col-12',
                m('.form-check', [
                  m("input#licenceAgreement[name=licenceAgreement][type='checkbox'].form-check-input.checkbox-primary-input[required]", {
                    onclick: updateAgreement,
                  }),
                  m("label.form-check-label[for=licenceAgreement]",
                    "I have read and agree to the ",
                    m(m.route.Link,
                      {
                        target: '_blank', href: LICENSE_URL
                      },
                      'End User License Agreement'
                    )
                  ),
                ]),
              ),
              m('.col-12',
                m('.form-check', [
                  m("input#policyAgreement[name=policyAgreement][type='checkbox'].form-check-input.checkbox-primary-input[required]", {
                    onclick: updateAgreement,
                  }),
                  m("label.form-check-label[for=policyAgreement]",
                    "I have read and agree to the ",
                    m(m.route.Link,
                      {
                        target: '_blank', href: POLICY_URL
                      },
                      'Samsung Privacy Policy'
                    )
                  ),
                ]),
              ),
              m('.col-12',
                m('.form-check', [
                  m("input#securityAgreement[name=securityAgreement][type='checkbox'].form-check-input.checkbox-primary-input[required]", {
                    onclick: updateAgreement,
                  }),
                  m("label.form-check-label[for=securityAgreement]",
                    "I have read and agree to the ",
                    m(m.route.Link,
                      {
                        target: '_blank',
                        href: SECURITY_GUIDELINE_URL
                      },
                      'Security Guideline for using Samsung Web Sites'
                    )
                  ),
                ]),
              ),
              m('.col-12.mt-4',
                m('.d-flex.flex-column.flex-sm-row.justify-content-center.gap-2',
                  m("button.btn.btn-primary[type='submit']", {
                    disabled: !areAllChecked(),
                  }, 'Agree'
                  ),
                  m("button.btn.btn-white[type='button']", {
                    onclick: disagreePolicy
                  }, 'Disagree'
                  )
                )
              )
            )
          )
        ),
        this.getBaseViews()
      )
    }
  }
}
